const urls = 0;
export const endurl = urls
  ? "https://inventory-manager-70zs.onrender.com/app"
  : "http://localhost:4000/app";
export const fronturl = urls
  ? "https://inventory-manager-front.onrender.com/"
  : "http://localhost:3000";
